import { useLocation } from 'react-router-dom'

export default (href: string): boolean => {
  return href === useLocation().pathname
}
